import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'

export const StatusCustom = styled.div<IconStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor }) => cursor};
  width: 1.25rem; // figma 20px
  height: 1.25rem; // figma 20px
  border-radius: 50%;
  background-color: ${({ colorIcon }) => colorIcon || COLORS.black};
`
